import {
  BottomSheetBackdrop,
  BottomSheetBackdropProps,
} from '@gorhom/bottom-sheet'
import { withLayoutContext } from 'expo-router'

import { createBottomSheetNavigator } from '@/components/navigation/bottomSheet/createBottomSheetNavigator'
import { BottomSheetNavigationOptions } from '@/components/navigation/bottomSheet/types'

const { Navigator } = createBottomSheetNavigator()

const BottomSheet = withLayoutContext<
  BottomSheetNavigationOptions,
  typeof Navigator,
  any,
  any
>(Navigator)

export default BottomSheet

export const renderBackdrop = (props: BottomSheetBackdropProps) => (
  <BottomSheetBackdrop
    {...props}
    disappearsOnIndex={-1}
    pressBehavior={'close'}
  />
)
